module.exports = __webpack_public_path__ + "static/media/wand3.fe2ab71c.png";